<script lang="ts">
  import { fade } from 'svelte/transition';
  import { clickOutside } from '../../helpers/sections-helper';
  import { asideShow } from '../../store/header';
  import type { NestedItem } from 'customer-components/lib/types';

  export let label: string;
  export let url: string;
  export let type: string;
  export let nestedItems: NestedItem[] = [];
  export let isFooter = false;
  export let showAll = false;
  export let isHeader = false;

  let nestedMenuState = [];

  function handleAnchorClick(event) {
    event.preventDefault();

    const anchor = document.getElementById(url);

    if (anchor) {
      window.scrollTo({
        top: anchor.offsetTop - 86,
        behavior: 'smooth',
      });

      asideShow.set(false);
    }
  }
</script>

{#if type === 'External'}
  <a href={url} on:click>
    <span
      class="label {isFooter ? 'footer' : ''} {isHeader ? 'dynamic-hover' : ''}"
      >{label}</span
    >
  </a>
{/if}

{#if type === 'Section'}
  <a href="#{url}" on:click>
    <span
      class="label {isFooter ? 'footer' : ''} {isHeader ? 'dynamic-hover' : ''}"
      >{label}</span
    >
  </a>
{/if}

{#if type === 'Page'}
  <a href={url} on:click>
    <span
      class="label {isFooter ? 'footer' : ''} {isHeader ? 'dynamic-hover' : ''}"
      >{label}</span
    >
  </a>
{/if}

{#if type === 'Parent'}
  <button
    class="parent"
    use:clickOutside
    on:click_outside={() => {
      nestedMenuState['' + label] = false;
    }}
    on:click={() => {
      nestedMenuState['' + label] =
        typeof nestedMenuState['' + label] == 'undefined'
          ? true
          : !nestedMenuState['' + label];
    }}
  >
    <span class="label {isHeader ? 'dynamic-hover' : ''}">{label}</span>
    {#if nestedMenuState['' + label] || showAll}
      <ul class="nestedItems {showAll ? 'showAll' : ''}" transition:fade>
        {#each nestedItems as link}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <!-- svelte-ignore a11y-no-noninteractive-element-to-interactive-role -->
          <li
            class="nestedItems-list"
            role="button"
            tabindex="0"
            on:click={() => asideShow.set(false)}
          >
            <a href={link.url}>
              <span class="label {isHeader ? 'dynamic-hover' : ''}"
                >{link.label}</span
              >
            </a>
          </li>
        {/each}
      </ul>
    {/if}
  </button>
{/if}

<style>
  a {
    position: relative;
    text-decoration: none;
    text-align: left;
    color: inherit;
  }
  a * {
    pointer-events: none;
  }
  .label {
    cursor: pointer;
  }
  .dynamic-hover:hover {
    color: var(--vlt-lp-primary);
  }
  .nestedItems {
    display: flex;
    font-size: 16px;
    line-height: 20px;
    flex-direction: column;
    grid-gap: 15px;
    list-style: none;
    width: 200px;
    padding: 40px;
    text-align: left;
    z-index: 4;
    align-items: flex-start;
    margin-top: 15px;
  }
  .nestedItems:not(.showAll) {
    margin: 0;
    position: absolute;
    top: calc(100% + 15px);
    left: 0;
    font-size: 16px;
    border-style: solid;
    border-width: 1px;
    border-color: #eff0f6;
    border-radius: 20px;
    background-color: var(--vlt-lp-background);
    box-shadow: 0 2px 12px 0 rgba(20, 20, 43, 0.08);
  }
  .parent {
    position: relative;
    border: unset;
    background: unset;
    outline: unset;
    color: inherit;
    font-size: inherit;
    text-align: left;
  }
  @media screen and (max-width: 900px) {
    .nestedItems {
      padding: 8px;
    }
  }
</style>
